import { FC } from "react";
import { useFilterContext } from "@app/network-portfolio-management/contexts/FilterContext";
import { QESAlert } from "@app/shared/qes-standards/Alert";

const RESTRICTED_FILTERS_MESSAGE =
  "This saved view includes filters that require additional permissions. Those filters were not applied; all other filters have been applied.";

/**
 * Banner shown above the filter bar when an applied saved view carried a Project Action filter the current user is
 * not permitted to use. The restricted filter is dropped (coerced to null in FilterContext) while every other
 * filter from the view is applied normally; this explains that to the user.
 */
export const RestrictedFiltersNotice: FC = () => {
  const { restrictedFiltersDropped } = useFilterContext();

  if (!restrictedFiltersDropped) {
    return null;
  }

  return (
    <QESAlert type="warning" persist={true}>
      <span data-testid="npm-restricted-filters-notice">{RESTRICTED_FILTERS_MESSAGE}</span>
    </QESAlert>
  );
};
